import { apiSlice as api } from "@/store/rtk-api/apiSlice"

import { uploadScannedFiles } from "./scannedUpload"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<uploadFilesResponse, uploadFilesRequest>({
      async queryFn(data, api, _extra, baseQuery) {
        try {
          return { data: await uploadScannedFiles(data, api.signal, async (args) => baseQuery(args)) }
        } catch {
          return {
            error: {
              status: 422,
              data: {
                success: false,
                code: "UPLOAD_UNAVAILABLE",
                error: "This file could not be uploaded. Please try another file.",
              },
            },
          }
        }
      },
    }),
    getFile: builder.query<getFileResponse, string>({
      query: (query) => ({
        url: `/v1/file/signed-url?q=${query}`,
        method: "get",
      }),
    }),
  }),
})

export const { useUploadFileMutation, useGetFileQuery } = injectedRtkApi

export default injectedRtkApi

interface uploadFilesRequest {
  files: FormData
  type: string
}
interface uploadFilesResponse {
  message: string
  files: FileSchema[]
}
export interface FileSchema {
  fileName: string
  key: string
  location: string
}
interface getFileResponse {
  success: boolean
  url: string
}
